import React from 'react';

const BuyMeCoffeeButton: React.FC = () => {
  return (
    <a 
      href="https://www.buymeacoffee.com/plainlazy" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="inline-flex items-center px-3 py-1 rounded-md bg-yellow-400 hover:bg-yellow-300 transition-colors text-center text-sm"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <img 
        src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" 
        alt="" 
        className="w-3 h-3 mr-1"
      />
      <span className="font-medium text-black">Buy me a coffee</span>
    </a>
  );
};

export default BuyMeCoffeeButton;